// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  gameCardioPreview: true,
  gameCardioEnabled: true,
  gameCardioProductionTest: false,
  urlApiPadrao: 'https://api.dashboard.dev.icons4u.com.br/',
  urlApiProcessamento: 'http://localhost:3014/',
  urlMedia: 'http://localhost:3020/media-volume/',
  X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
  debugMode: 'info',
};
